import { type Row } from '../../../components/CustomTable/types'

// The instructor_optout endpoint 404s on a missing/invalid sectionId (rejected by the
// <uuid:section_id> route converter), which surfaces as an unhelpful generic error toast — resolve
// and validate it up front so the caller can short-circuit with a clear message instead.
export const resolveInstructorOptOutSectionId = (row: Row | null): string | null => {
  const sectionId = row?.data?.linkedSection?.sectionId
  return typeof sectionId === 'string' && sectionId.length > 0 ? sectionId : null
}
